import { Hub } from 'aws-amplify';
import { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { useBrand } from '@src/contexts/brand-context';
import { authService } from '@src/features/auth/services';
import { getLoginUrl } from '@src/features/auth/utils/auth';

import { AuthContext } from './auth.context';
import { AuthProviderProps } from './types';

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { brand } = useBrand();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const authCallback = useCallback(
    ({
      payload,
    }: {
      payload: {
        event: string;
      };
    }) => {
      const { event } = payload;
      const eventCallbacks: Record<string, VoidFunction | undefined> = {
        signIn: () => setIsLoggedIn(true),
      };

      eventCallbacks[event]?.();
    },
    [],
  );

  const configurationQuery = useQuery(
    ['auth', brand, typeof window],
    () => {
      const loginUrl = getLoginUrl();

      authService.configure({
        loginUrl,
        logoutUrl: brand.websiteUrl,
      });
    },
    {
      enabled: typeof window !== 'undefined',
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess: () => Hub.listen('auth', authCallback),
    },
  );

  // Remove listener on unmount
  useEffect(() => {
    return () => Hub.remove('auth', authCallback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isReady: configurationQuery.isSuccess,
        isLoggedIn,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
